import React from 'react';
import classnames from 'classnames';
import { Button } from '@fiverr-private/button';
import { Icon, Section } from '@fiverr-private/fit';
import { s_exclamation_circle } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import styles from './index.module.scss';

const T_KEY = 'freelancer_page.helpBar';

const HelpBar = () => {
    const { isCurrentUser, username } = useFreelancerPageContext();

    if (!isCurrentUser) {
        return null;
    }

    return (
        <div className={classnames(styles.wrapper, 'flex flex-center')}>
            <Section className={styles.content}>
                <div className="flex flex-items-center">
                    <Icon className={styles.icon} color="white">
                        {s_exclamation_circle}
                    </Icon>
                    <div className="m-r-8 m-l-8">
                        <I18n k={`${T_KEY}.profile_preview`} />{' '}
                        <a
                            className={styles.link}
                            target="_blank"
                            href="/support/articles/4412909373841?segment=business"
                            data-testid={'help-center-link'}
                        >
                            <I18n k={`${T_KEY}.help_center_link`} />
                        </a>
                    </div>
                </div>
                <Button
                    intent="secondary"
                    size="sm"
                    href={pathfinder('seller_page', { username }, { query: { up_rollout: 'true' } })}
                    data-testid={'edit-profile-link'}
                >
                    <I18n k={`${T_KEY}.update_profile`} />
                </Button>
            </Section>
        </div>
    );
};

export default HelpBar;
